/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  getCodeMappings,
  getErrorCode,
  hasDiagCode
} from '@ion/core/src/services/JobMetaDefinitions';
import Tooltip from '@ion/dls/src/components/tooltip/Tooltip';
import {GridResult} from '@ion/dls/src/grid/PaginationControls';
import {DLSTheme} from '@ion/dls/src/types/types';

// defines the styles used by the attributes and values cells ...
export const useStyles = makeStyles((theme: DLSTheme) => ({
  jobMeta : {
    position     : 'relative',
    lineHeight   : '20px',
    textOverflow : 'ellipsis',
    wordBreak    : 'break-word',
    overflow     : 'hidden'
  }
}));

/**
 * Grid renderer component to Display Mapped values of StatCode
 * and DiagCode.
 */
export const JobMeta = ({data}: GridResult) => {
  const {
    data: {
      device : {
        extensions = {}
      } = {},
      taskStatus: {
        errorCodes = {}
      } = {}
    } = {}
  } = data || {};

  const {
    statCode,
    diagCode,
    diagCode32Bit
  } = getCodeMappings();

  const classes = useStyles();
  const error   = errorCodes?.[0];
  const appId   = extensions?.appId;

  return hasDiagCode(error) ? (
    <Tooltip arrow
      placement={'bottom'}
      title={<span>{getErrorCode({error, appId, statCode, diagCode, diagCode32Bit})}</span>}>
      <div className={classes.jobMeta}>
        {getErrorCode({error, appId, statCode, diagCode, diagCode32Bit})}
      </div>
    </Tooltip>
  ) : error;
};

export default JobMeta;
